import {
  LIST_PARTNER_REQUEST,
  LIST_PARTNER_SUCCESS,
  LIST_PARTNER_FAIL,
  LIST_PARTNER_SUMMARY_REQUEST,
  LIST_PARTNER_SUMMARY_SUCCESS,
  LIST_PARTNER_SUMMARY_FAIL,
  CREATE_PARTNER_REQUEST,
  CREATE_PARTNER_SUCCESS,
  CREATE_PARTNER_FAIL,
  DETAIL_PARTNER_REQUEST,
  DETAIL_PARTNER_SUCCESS,
  DETAIL_PARTNER_FAIL,
  UPDATE_PARTNER_REQUEST,
  UPDATE_PARTNER_SUCCESS,
  UPDATE_PARTNER_FAIL,
  DELETE_PARTNER_REQUEST,
  DELETE_PARTNER_SUCCESS,
  DELETE_PARTNER_FAIL,
  LIST_PARTNER_BRANCH_REQUEST,
  LIST_PARTNER_BRANCH_SUCCESS,
  LIST_PARTNER_BRANCH_FAIL,
  LIST_PARTNER_BRANCH_SUMMARY_REQUEST,
  LIST_PARTNER_BRANCH_SUMMARY_SUCCESS,
  LIST_PARTNER_BRANCH_SUMMARY_FAIL,
  CREATE_PARTNER_BRANCH_REQUEST,
  CREATE_PARTNER_BRANCH_SUCCESS,
  CREATE_PARTNER_BRANCH_FAIL,
  DETAIL_PARTNER_BRANCH_REQUEST,
  DETAIL_PARTNER_BRANCH_SUCCESS,
  DETAIL_PARTNER_BRANCH_FAIL,
  UPDATE_PARTNER_BRANCH_REQUEST,
  UPDATE_PARTNER_BRANCH_SUCCESS,
  UPDATE_PARTNER_BRANCH_FAIL,
  DELETE_PARTNER_BRANCH_REQUEST,
  DELETE_PARTNER_BRANCH_SUCCESS,
  DELETE_PARTNER_BRANCH_FAIL,
  DETAIL_PARTNER_RESET,
  RESET_LIST_PARTNER_SUMMARY,
  RESET_LIST_PARTNER_BRANCH_SUMMARY,
  SUMMARY_PAYMENT_OPTION_REQUEST,
  SUMMARY_PAYMENT_OPTION_SUCCESS,
  SUMMARY_PAYMENT_OPTION_FAIL,
  LIST_PARTNER_INVOICE_ADDRESS_REQUEST,
  LIST_PARTNER_INVOICE_ADDRESS_SUCCESS,
  LIST_PARTNER_INVOICE_ADDRESS_FAIL,
  CREATE_PARTNER_INVOICE_ADDRESS_REQUEST,
  CREATE_PARTNER_INVOICE_ADDRESS_SUCCESS,
  CREATE_PARTNER_INVOICE_ADDRESS_FAIL,
  DETAIL_PARTNER_INVOICE_ADDRESS_REQUEST,
  DETAIL_PARTNER_INVOICE_ADDRESS_SUCCESS,
  DETAIL_PARTNER_INVOICE_ADDRESS_FAIL,
  RESET_DETAIL_PARTNER_INVOICE_ADDRESS,
  UPDATE_PARTNER_INVOICE_ADDRESS_REQUEST,
  UPDATE_PARTNER_INVOICE_ADDRESS_SUCCESS,
  UPDATE_PARTNER_INVOICE_ADDRESS_FAIL,
  DELETE_PARTNER_INVOICE_ADDRESS_REQUEST,
  DELETE_PARTNER_INVOICE_ADDRESS_SUCCESS,
  DELETE_PARTNER_INVOICE_ADDRESS_FAIL,
  LIST_PARTNER_INVOICE_ADDRESS_SUMMARY_REQUEST,
  LIST_PARTNER_INVOICE_ADDRESS_SUMMARY_SUCCESS,
  LIST_PARTNER_INVOICE_ADDRESS_SUMMARY_FAIL,
  LIST_PARTNER_DOCUMENT_REQUEST,
  LIST_PARTNER_DOCUMENT_SUCCESS,
  LIST_PARTNER_DOCUMENT_FAIL,
  CREATE_PARTNER_DOCUMENT_REQUEST,
  CREATE_PARTNER_DOCUMENT_SUCCESS,
  CREATE_PARTNER_DOCUMENT_FAIL,
  UPDATE_PARTNER_DOCUMENT_REQUEST,
  UPDATE_PARTNER_DOCUMENT_SUCCESS,
  UPDATE_PARTNER_DOCUMENT_FAIL,
  DELETE_PARTNER_DOCUMENT_REQUEST,
  DELETE_PARTNER_DOCUMENT_SUCCESS,
  DELETE_PARTNER_DOCUMENT_FAIL,
  DOWNLOAD_PARTNER_DOCUMENT_REQUEST,
  DOWNLOAD_PARTNER_DOCUMENT_SUCCESS,
  DOWNLOAD_PARTNER_DOCUMENT_FAIL,
  LIST_PARTNER_DOCUMENT_CLASSIFICATION_REQUEST,
  LIST_PARTNER_DOCUMENT_CLASSIFICATION_SUCCESS,
  LIST_PARTNER_DOCUMENT_CLASSIFICATION_FAIL
} from '../../constants/partners'

const initialState = {
  loading: false,
  loadingDetail: false,
  loadingDelete: false,
  loadingPartner: false,
  loadingPartnerBranch: false,
  loadingGetSummary: false,
  partners: [],
  partnersSummary: [],
  partnersBranches: [],
  partnersBranchesSummary: [],
  partner: {},
  partnerBranch: {},
  invoiceAddresses: [],
  listPartnerInvoiceAddress: [],
  invoiceAddressDetail: {},
  loadingInvoiceAddress: false,
  loadingInvoiceAddressDetail: false,
  error: null,
  pageable: {},
  status: null,
  paymentOptionSummary: [],
  partnerDocuments: [],
  partnerDocumentsPageable: {},
  loadingPartnerDocuments: false,
  loadingCreatePartnerDocument: false,
  loadingUpdatePartnerDocument: false,
  loadingDeletePartnerDocument: false,
  loadingDownloadPartnerDocument: false,
  partnerDocumentClassificationOptions: [],
  loadingPartnerDocumentClassification: false
}

const listPartnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_PARTNER_REQUEST:
      return { ...state, loading: true }
    case LIST_PARTNER_SUCCESS:
      return { ...state, loading: false, partners: action.payload, pageable: action.pageable }
    case LIST_PARTNER_FAIL:
      return { ...state, loading: false, error: action.payload, partners: [] }
    case LIST_PARTNER_SUMMARY_REQUEST:
      return { ...state, loadingPartner: true }
    case LIST_PARTNER_SUMMARY_SUCCESS:
      return { ...state, loadingPartner: false, partnersSummary: action.payload }
    case LIST_PARTNER_SUMMARY_FAIL:
      return { ...state, loadingPartner: false, error: action.payload }
    case RESET_LIST_PARTNER_SUMMARY:
      return { ...state, loading: false, partnersSummary: [] }
    case CREATE_PARTNER_REQUEST:
      return { ...state, loading: true }
    case CREATE_PARTNER_SUCCESS:
      return { ...state, loading: false, status: 'success' }
    case CREATE_PARTNER_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DETAIL_PARTNER_REQUEST:
      return { ...state, loadingDetail: true, partner: {} }
    case DETAIL_PARTNER_SUCCESS:
      return { ...state, loadingDetail: false, partner: action.payload }
    case DETAIL_PARTNER_FAIL:
      return { ...state, loadingDetail: false, error: action.payload, partner: {} }
    case DETAIL_PARTNER_RESET:
      return { ...state, loadingDetail: false, partner: {} }
    case UPDATE_PARTNER_REQUEST:
      return { ...state, loading: true }
    case UPDATE_PARTNER_SUCCESS:
      return { ...state, loading: false, status: 'success' }
    case UPDATE_PARTNER_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DELETE_PARTNER_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_PARTNER_SUCCESS:
        const partnerId = action.payload
        const partnerIndex = state.partners.findIndex(partner => partner.id === partnerId)
        state.partners.splice(partnerIndex, 1)

      return { ...state, loadingDelete: false, status: 'success', partners: state.partners }
    case DELETE_PARTNER_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case LIST_PARTNER_BRANCH_REQUEST:
      return { ...state, loading: true }
    case LIST_PARTNER_BRANCH_SUCCESS:
      return { ...state, loading: false, partnersBranches: action.payload, pageable: action.pageable }
    case LIST_PARTNER_BRANCH_FAIL:
      return { ...state, loading: false, error: action.payload, partnersBranches: [] }
    case LIST_PARTNER_BRANCH_SUMMARY_REQUEST:
      return { ...state, loadingPartnerBranch: true }
    case LIST_PARTNER_BRANCH_SUMMARY_SUCCESS:
      return { ...state, loadingPartnerBranch: false, partnersBranchesSummary: action.payload }
    case LIST_PARTNER_BRANCH_SUMMARY_FAIL:
      return { ...state, loadingPartnerBranch: false, error: action.payload, partnersBranchesSummary: [] }
    case RESET_LIST_PARTNER_BRANCH_SUMMARY:
      return { ...state, loading: false, partnersBranchesSummary: [] }
    case CREATE_PARTNER_BRANCH_REQUEST:
      return { ...state, loading: true }
    case CREATE_PARTNER_BRANCH_SUCCESS:
      return { ...state, loading: false, status: 'success' }
    case CREATE_PARTNER_BRANCH_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DETAIL_PARTNER_BRANCH_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_PARTNER_BRANCH_SUCCESS:
      return { ...state, loadingDetail: false, partnerBranch: action.payload }
    case DETAIL_PARTNER_BRANCH_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_PARTNER_BRANCH_REQUEST:
      return { ...state, loading: true }
    case UPDATE_PARTNER_BRANCH_SUCCESS:
      return { ...state, loading: false, status: 'success' }
    case UPDATE_PARTNER_BRANCH_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DELETE_PARTNER_BRANCH_REQUEST:
      return { ...state, loading: true }
    case DELETE_PARTNER_BRANCH_SUCCESS:
      return { ...state, loading: false, status: 'success' }
    case DELETE_PARTNER_BRANCH_FAIL:
      return { ...state, loading: false, error: action.payload }
    case SUMMARY_PAYMENT_OPTION_REQUEST:
      return { ...state, loadingGetSummary: true }
    case SUMMARY_PAYMENT_OPTION_SUCCESS:
      return { ...state, loadingGetSummary: false, paymentOptionSummary: action.payload }
    case SUMMARY_PAYMENT_OPTION_FAIL:
      return { ...state, loadingGetSummary: false, error: action.payload }
    case LIST_PARTNER_INVOICE_ADDRESS_REQUEST:
      return { ...state, loadingInvoiceAddress: true }
    case LIST_PARTNER_INVOICE_ADDRESS_SUCCESS:
      return {
        ...state,
        loadingInvoiceAddress: false,
        invoiceAddresses: action.payload,
        pageable: action.pageable
      }
    case LIST_PARTNER_INVOICE_ADDRESS_FAIL:
      return {
        ...state,
        loadingInvoiceAddress: false,
        error: action.payload,
        invoiceAddresses: []
      }
    case CREATE_PARTNER_INVOICE_ADDRESS_REQUEST:
      return { ...state, loading: true }
    case CREATE_PARTNER_INVOICE_ADDRESS_SUCCESS:
      return { ...state, loading: false, status: 'success' }
    case CREATE_PARTNER_INVOICE_ADDRESS_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DETAIL_PARTNER_INVOICE_ADDRESS_REQUEST:
      return { ...state, loadingInvoiceAddressDetail: true }
    case DETAIL_PARTNER_INVOICE_ADDRESS_SUCCESS:
      return {
        ...state,
        loadingInvoiceAddressDetail: false,
        invoiceAddressDetail: action.payload
      }
    case DETAIL_PARTNER_INVOICE_ADDRESS_FAIL:
      return { ...state, loadingInvoiceAddressDetail: false, error: action.payload }
    case RESET_DETAIL_PARTNER_INVOICE_ADDRESS:
      return { ...state, invoiceAddressDetail: {}, loadingInvoiceAddressDetail: false }
    case UPDATE_PARTNER_INVOICE_ADDRESS_REQUEST:
      return { ...state, loading: true }
    case UPDATE_PARTNER_INVOICE_ADDRESS_SUCCESS:
      return { ...state, loading: false, status: 'success' }
    case UPDATE_PARTNER_INVOICE_ADDRESS_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DELETE_PARTNER_INVOICE_ADDRESS_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_PARTNER_INVOICE_ADDRESS_SUCCESS:
      return { ...state, loadingDelete: false, status: 'success' }
    case DELETE_PARTNER_INVOICE_ADDRESS_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case LIST_PARTNER_INVOICE_ADDRESS_SUMMARY_REQUEST:
      return { ...state, loading: true, listPartnerInvoiceAddress: [] }
    case LIST_PARTNER_INVOICE_ADDRESS_SUMMARY_SUCCESS:
      return { ...state, loading: false, listPartnerInvoiceAddress: action.payload }
    case LIST_PARTNER_INVOICE_ADDRESS_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload, listPartnerInvoiceAddress: [] }
    case LIST_PARTNER_DOCUMENT_REQUEST:
      return { ...state, loadingPartnerDocuments: true }
    case LIST_PARTNER_DOCUMENT_SUCCESS:
      return {
        ...state,
        loadingPartnerDocuments: false,
        partnerDocuments: action.payload,
        partnerDocumentsPageable: action.pageable
      }
    case LIST_PARTNER_DOCUMENT_FAIL:
      return {
        ...state,
        loadingPartnerDocuments: false,
        error: action.payload,
        partnerDocuments: []
      }
    case CREATE_PARTNER_DOCUMENT_REQUEST:
      return { ...state, loadingCreatePartnerDocument: true }
    case CREATE_PARTNER_DOCUMENT_SUCCESS:
      return { ...state, loadingCreatePartnerDocument: false }
    case CREATE_PARTNER_DOCUMENT_FAIL:
      return { ...state, loadingCreatePartnerDocument: false, error: action.payload }
    case UPDATE_PARTNER_DOCUMENT_REQUEST:
      return { ...state, loadingUpdatePartnerDocument: true }
    case UPDATE_PARTNER_DOCUMENT_SUCCESS:
      return { ...state, loadingUpdatePartnerDocument: false }
    case UPDATE_PARTNER_DOCUMENT_FAIL:
      return { ...state, loadingUpdatePartnerDocument: false, error: action.payload }
    case DELETE_PARTNER_DOCUMENT_REQUEST:
      return { ...state, loadingDeletePartnerDocument: true }
    case DELETE_PARTNER_DOCUMENT_SUCCESS:
      return { ...state, loadingDeletePartnerDocument: false }
    case DELETE_PARTNER_DOCUMENT_FAIL:
      return { ...state, loadingDeletePartnerDocument: false, error: action.payload }
    case DOWNLOAD_PARTNER_DOCUMENT_REQUEST:
      return { ...state, loadingDownloadPartnerDocument: true }
    case DOWNLOAD_PARTNER_DOCUMENT_SUCCESS:
      return { ...state, loadingDownloadPartnerDocument: false }
    case DOWNLOAD_PARTNER_DOCUMENT_FAIL:
      return { ...state, loadingDownloadPartnerDocument: false, error: action.payload }
    case LIST_PARTNER_DOCUMENT_CLASSIFICATION_REQUEST:
      return {
        ...state,
        loadingPartnerDocumentClassification: true,
        partnerDocumentClassificationOptions: []
      }
    case LIST_PARTNER_DOCUMENT_CLASSIFICATION_SUCCESS:
      return {
        ...state,
        loadingPartnerDocumentClassification: false,
        partnerDocumentClassificationOptions: action.payload
      }
    case LIST_PARTNER_DOCUMENT_CLASSIFICATION_FAIL:
      return {
        ...state,
        loadingPartnerDocumentClassification: false,
        error: action.payload,
        partnerDocumentClassificationOptions: []
      }
    default:
      return state
  }
}

export default listPartnerReducer
